var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-data-table',{staticClass:"elevation-1",attrs:{"headers":_vm.headers,"items":_vm.departmentDownloadables,"items-per-page":15,"dense":""},scopedSlots:_vm._u([{key:"item.Url",fn:function(ref){
var item = ref.item;
return [_c('a',{attrs:{"target":"_blank","href":_vm.$api_url+item.Url}},[_vm._v(" "+_vm._s(item.Name)+" ")])]}}])})],1)}
var staticRenderFns = []

export { render, staticRenderFns }